import { lazy } from "react"
import { RouteProps } from "../features.types"

const OrdersController = lazy(() => import("./orders-controller"))
const OrdersHome = lazy(() => import("./orders"))
// define route constant
export const ORDERS_ROUTE = "orders"

//define routes
export const Orders: RouteProps[] = [
  {
    path: `${ORDERS_ROUTE}`,
    Component: OrdersController,
    children: [
      {
        index: true,
        Component: OrdersHome,
      },
    ],
  },
]
